import { RouteDeclaration, configureStates } from "../../core/router/router-helper.provider";
import angular from "angular";

export const routes: RouteDeclaration[] = [{
    state: "onboarding",
    config: {
        name: "onboarding",
        abstract: true,
        url: "/onboarding"
    }
}, {
    // Legacy route
    state: "onboarding.submittedApplications",
    config: {
        name: "onboarding.submittedApplications",
        url: "/submittedapplications",
        redirectTo: "onboarding.application.list"
    }
}, {
    state: "onboarding.application",
    config: {
        name: "onboarding.application",
        abstract: true,
        url: "/applications"
    }
}, {
    state: "onboarding.application.list",
    config: {
        name: "onboarding.application.list",
        url: "",
        component: "apexOnboardingApplicationsList",
        data: {
            pageHeader: "Submitted Onboarding Applications"
        }
    }
}];

export const OnboardingRoutingModule = angular
    .module("apex.mainApp.onboarding.routing", [])
    .run(configureStates(routes))
    .name;
